module.exports = __webpack_public_path__ + "assets/img/house.3b716eb8.png";